import styled from 'styled-components';

export const ChartContentWrapper = styled.div`
  width: 360px;
  margin: 0 auto;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;
